export const APPLY_PATIENT_DATA_ACCESS = '/api/PatientDataAccess/Apply';
export const AUTHORIZE_PATIENT_DATA_ACCESS = '/api/PatientDataAccess/Autorize';
export const STATUS_PATIENT_DATA_ACCESS = '/api/PatientDataAccess/Status';
